
import React from "react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { CalendarIcon } from "lucide-react";
import { format } from "date-fns";
import { cn } from "@/lib/utils";
import { useForm } from "@/context/FormContext";
import { FormFieldType } from "@/types/form";
import FieldWrapper from "./FieldWrapper";
import { DateTime } from "luxon";
interface DateFieldProps {
  element: FormFieldType;
}

export const DateField: React.FC<DateFieldProps> = ({ element }) => {
  const { formData, setField } = useForm();
  
  const handleChange = (date: Date | undefined) => {
    const datetime = DateTime.fromJSDate(date as Date).setZone("Asia/Bangkok", { keepLocalTime: true });
    setField(element.name!, datetime.toISO());
  };

  return (
    <FieldWrapper element={element}>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            className={cn(
              "w-full justify-start text-left font-normal",
              !formData[element.name!] && "text-muted-foreground"
            )}
          >
            <CalendarIcon className="mr-2 h-4 w-4" />
            {formData[element.name!] ? 
              format(new Date(formData[element.name!] as string), "PPP") : 
              "Pick a date"
            }
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0">
          <Calendar
            mode="single"
            selected={formData[element.name!] ? new Date(formData[element.name!] as string) : undefined}
            onSelect={(date) => handleChange(date)}
            initialFocus
          />
        </PopoverContent>
      </Popover>
    </FieldWrapper>
  );
};

export default DateField;
